import { handleActions } from 'redux-actions'
import { setSessionActions, resetState } from '../../actions'

const defaultValue = []

export default handleActions(
  {
    [setSessionActions](_, { payload: actions }) {
      return actions
    },
    [resetState]() {
      return defaultValue
    },
  },
  defaultValue
)
